// Hardcoded CUID ID's to match the monolith.
const SUBJECT_PRODUCT_STREAMS = {
  EssentialsNews: 'clilvwpnz00072e644z4xu7vz',
  ELA: 'ck76k7hns00023e57ir4qn94h',
  Science: 'ck76k4yfp00003e5736p1g7x6',
  SS: 'ck76k5jf100013e57sgsj30mr',
  STEM: 'cm6zidqab00063b6oyld23f98'
};

const SUBJECT_PRODUCT_STREAMS_BY_ID = {
  clilvwpnz00072e644z4xu7vz: 'Essentials',
  ck76k7hns00023e57ir4qn94h: 'ELA',
  ck76k4yfp00003e5736p1g7x6: 'Science',
  ck76k5jf100013e57sgsj30mr: 'SS',
  cm6zidqab00063b6oyld23f98: 'STEM'
};

const SUBJECT_PRODUCT_STREAM_IDS = Object.values(SUBJECT_PRODUCT_STREAMS);

const LITE_STREAM = Object.freeze({
  uid: '0x2ae227380',
  slug: 'lite',
  id: 'clfugywx100073569vvgvoqx3',
  streamTitle: 'Lite',
  name: 'Lite',
  streamDescription: 'Content that belongs in the Newsela Lite product.',
  custom: false,
  exemplar: false,
  isBrandedProduct: false,
  subject: 'OTHER',
  createdAt: '2023-03-30T02:01:09.628Z',
  updatedAt: '2024-01-02T16:26:19.835Z'
});

const ARTICLE_TYPES_WITHOUT_LEXILE = [
  'ARTICLE_POEM'
];

// Subject products and lite stream have different ways of being applied to
// Content, so in order to prevent end-user confusion, we exclude them
// from appearing with other streams in certain queries and UI elements.
const EXCLUDED_STREAM_IDS = [...Object.values(SUBJECT_PRODUCT_STREAMS), LITE_STREAM.id];

// Stream IDs that only exclude subject product streams (allows Lite stream).
// Used for content types that support Lite stream selection.
const SUBJECT_PRODUCT_STREAM_IDS_ONLY = Object.values(SUBJECT_PRODUCT_STREAMS);

// When lexile score is <-400 or cannot be calculated, we use these values for lexile and rawLexile.
const NO_LEXILE = '---L';
const NO_RAW_LEXILE = -9999;

const READING_COMPREHENSION_STREAM_TITLE = 'Reading Comprehension';

const READING_SKILLS_IDS = [
  'ckmmfeego00073e5axsfuczqm',
  'ckmmf9uwt00013e5aufnod848',
  'ckmmfex1j000c3e5anupm1gfv',
  'ckmmfdxcj00033e5aq2r9soen',
  'ckmmfglnv000k3e5arlboodf3',
  'ckmmfh3s1000m3e5aswc22jgv',
  'ckmmffx0j000g3e5adkygp3dd',
  'ckmmfen8l000a3e5a3yci813m',
  'ckmmfg98e000i3e5ahym5p9aj',
  'ckmmfe5w800053e5ahc1l0vwv',
  'ckmmffjca000e3e5aa40p4z86'
];

module.exports = {
  ARTICLE_TYPES_WITHOUT_LEXILE,
  EXCLUDED_STREAM_IDS,
  LITE_STREAM,
  READING_COMPREHENSION_STREAM_TITLE,
  READING_SKILLS_IDS,
  NO_LEXILE,
  NO_RAW_LEXILE,
  SUBJECT_PRODUCT_STREAMS,
  SUBJECT_PRODUCT_STREAMS_BY_ID,
  SUBJECT_PRODUCT_STREAM_IDS,
  SUBJECT_PRODUCT_STREAM_IDS_ONLY,
};
